import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"

import { forceLogout } from "../../service"

const Logout = (props: any) => {

  useEffect(() => {
    // Clears the token and ALL persisted state (user, factory selection and any
    // saved report drafts), then hard-reloads to /login. This prevents the next
    // user on a shared machine from inheriting the previous session's data.
    forceLogout()
  }, [])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
